import type { PropsWithChildren } from "react";
import { Box, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const ActionButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  color: theme.palette.primary.dark,
  backgroundColor: theme.palette.primary.extralight,
  "&:hover": {
    backgroundColor: theme.palette.primary.hover,
    cursor: "pointer",
  },
  borderRadius: "8px",
  padding: "16px",
}));

const Column = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: "100%",
  maxWidth: "149px",
  [theme.breakpoints.up(541)]: {
    maxWidth: "none",
  },
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
}));

const IconWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const IconContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  backgroundColor: theme.palette.primary.main,
}));

export const NewDocumentIcon = styled(AddIcon)(({ theme }) => ({
  width: "24px",
  height: "24px",
  color: theme.palette.icon.contrast,
}));

interface Props {
  onClick: () => void;
  icon?: React.ReactNode;
}

export const HomeActionButton: React.FC<PropsWithChildren<Props>> = ({
  onClick,
  icon,
  children,
}) => {
  return (
    <ActionButtonContainer onClick={onClick}>
      <Column>
        {icon && (
          <IconWrapper>
            <IconContainer>{icon}</IconContainer>
          </IconWrapper>
        )}
        {children}
      </Column>
    </ActionButtonContainer>
  );
};
